<template>
  <div class="uk-container">
    <div class="uk-flex-center" uk-grid>
      <div class="uk-width-large">
        <div v-if="dentist.r" class="uk-alert-warning" uk-alert>
          <div class="uk-text-center">
            <p>This dentist submitted a request to change the information about their practice.</p>
            <p class="uk-margin-remove-bottom">You can find it in <b>Requests</b> section.</p>
          </div>
        </div>

        <div class="uk-card uk-card-default uk-margin">
          <div class="uk-card-header uk-text-center">
            <h3 class="uk-card-title">Practice Information</h3>
            <p class="uk-text-meta">{{ dentist.id }}</p>
          </div>
          <div class="uk-card-body">
            <practice-form ref="form-practice" type="manage" :dentist="dentist" :form.sync="form" />
          </div>
          <div class="uk-card-footer uk-text-center">
            <button class="uk-button uk-button-primary" :disabled="disabled" @click="update">Update</button>
          </div>
        </div>

        <div class="uk-card uk-card-default uk-margin">
          <div class="uk-card-header uk-text-center">
            <h3 class="uk-card-title">Users Information</h3>
            <p class="uk-text-meta">Accounts connected to this Dentist.</p>
            <!-- <p class="uk-text-meta"><b>Note</b>: Accounts can be viewed but cannot be managed using EDD CRM at the moment.</p> -->
          </div>
          <div>
            <table class="uk-table uk-table-middle uk-table-divider uk-table-hover uk-text-center uk-margin-remove">
              <thead>
                <tr>
                  <th class="uk-width-small">Name</th>
                  <th class="uk-width-small">Email</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="user in users"
                  :key="user.id"
                  class="uk-visible-toggle"
                  tabindex="-1"
                  @click="manageUser(user.id)"
                >
                  <td>{{ user.name.first }} {{ user.name.last }}</td>
                  <td>{{ user.email }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="uk-card-footer uk-text-center">
            <router-link :to="{ name: 'dentist-user-create', params: { id: id }}" class="uk-button uk-button-primary">Add User</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PracticeForm from '@/components/form/Practice.vue'

export default {
  name: 'ViewDentistManage',

  components: { PracticeForm },

  data() {
    return {
      id: this.$route.params.id,
      form: null
    }
  },

  computed: {
    dentist() {
      return this.$store.getters['dentists/find'](this.id)
    },

    users() {
      return this.$store.getters['users/getByType'](3).filter((user) => user.dentist === this.id)
    },

    disabled() {
      const check = []

      // Check if there is a pending request from the dentist to update details of the practice
      // check.push(this.dentist.r)

      // Check if there is any change
      if (this.form) {
        const updateCheck = [
          this.form.email === this.dentist.email,
          this.form.area === this.dentist.area,
          this.form.phone.primary === this.dentist.phone.primary,
          this.form.phone.secondary === this.dentist.phone.secondary,
          this.form.name === this.dentist.name,
          this.form.location.house === this.dentist.location.house,
          this.form.location.street === this.dentist.location.street,
          this.form.location.city === this.dentist.location.city,
          this.form.location.postcode === this.dentist.location.postcode,
          this.form.location.geopoint.lat === this.dentist.location.geopoint.latitude,
          this.form.location.geopoint.long === this.dentist.location.geopoint.longitude,
          this.form.notifications.email === this.dentist.notifications.email,
          this.form.notifications.sms === this.dentist.notifications.sms,
          this.form.status === this.dentist.status
        ]

        check.push(!updateCheck.includes(false))
      }

      return check.includes(true)
    }
  },

  methods: {
    manageUser(id) {
      this.$router.push({ name: 'dentist-user-manage', params: { dentist: this.id, user: id } })
    },

    async update() {
      const valid = await this.$refs['form-practice'].validate()

      if (valid) {
        let geopoint = null

        try {
          geopoint = new this.$firebase.firestore.GeoPoint(Number(this.form.location.geopoint.lat), Number(this.form.location.geopoint.long))
        } catch (error) {
          this.$uikit.notification(error, { status: 'danger' })
        }

        const data = {
          name: this.form.name,
          email: this.form.email,
          area: this.form.area.uid,
          phone: {
            primary: this.form.phone.primary,
            secondary: this.form.phone.secondary
          },
          location: {
            house: this.form.location.house,
            street: this.form.location.street,
            city: this.form.location.city,
            postcode: this.form.location.postcode,
            geopoint
          },
          features: this.form.features,
          notifications: this.form.notifications,
          status: this.form.status
        }

        this.$firebase.firestore().collection(this.$globals.firebase.collection.dentists).doc(this.id).update(data)
          .then(() => {
            this.$uikit.modal.alert('Data was updated successfully!')
          })
          .catch((error) => {
            this.$uikit.modal.alert(`<div class="uk-text-center">Something went wrong!</div><div class="uk-margin">${error}</div>`)
          })
      }
    }
  }
}
</script>
